import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import Pager from 'components/widgets/Pager';
import ModelDesignFields from './ModelDesignFields';
import ModelDesignEndpoints from './ModelDesignEndpoints';

class ModelDesignView extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
	}

	getTitle() {
		switch (this.props.mode) {
			case 'edit':
				return this.intl.formatMsg('Edit Model');
			case 'compose':
				return this.intl.formatMsg('Composite Model');
			case 'create':
				return this.intl.formatMsg('New Model');
			default:
				throw new Error(`Unknown mode: ${this.props.mode}`);
		}
	}

	render() {
		return (
			<div className="model-design-view">
				<Pager
					title={this.getTitle()}
					onSave={this.props.onSave}
					onCancel={this.props.onCancel}
				>
					<ModelDesignFields
						modelDef={this.props.modelDef}
						connectors={this.props.connectors}
						models={this.props.models}
						mode={this.props.mode}
						onChange={this.props.onChange}
					/>
					<ModelDesignEndpoints
						modelDef={this.props.modelDef}
						updateModelDef={this.props.updateModelDef}
					/>
				</Pager>
			</div>
		);
	}
}

ModelDesignView.propTypes = {
	modelDef: PropTypes.object,
	mode: PropTypes.oneOf([
		'create', 'edit', 'compose'
	]).isRequired,
	models: PropTypes.object.isRequired,
	connectors: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	updateModelDef: PropTypes.func.isRequired
};

export default injectIntl(ModelDesignView);
